
const mealPlanIcon = () => {
  return (
    <svg version="1.1" id="Capa_1"  x="0px" y="0px" viewBox="0 0 489.672 489.672" style={{enableBackground:'new 0 0 489.672 489.672;'}} >
<g>
  <g>
    <path d="M242.38,44.104c-1.56-1.512-3.704-2.32-5.856-2.224c-14.04,0.552-28.04,2.52-41.6,5.864l3.832,15.536
      c9.832-2.424,19.912-4.064,30.08-4.904v151.296H57.044c2.104-9.92,5-19.68,8.64-29.128l-14.92-5.76
      c-5.176,13.408-8.96,27.408-11.248,41.608c-0.376,2.32,0.288,4.672,1.808,6.464c1.52,1.792,3.744,2.816,6.088,2.816h189.424
      c4.424,0,8-3.584,8-8v-167.8C244.836,47.696,243.956,45.616,242.38,44.104z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M411.228,124.864l-12.8,9.608c25.128,33.432,38.408,73.264,38.408,115.2c0,2.552-0.064,5.2-0.192,8H276.836V60.384
      c12.712,2.136,25.176,5.544,37.168,10.176l5.768-14.92c-16.024-6.192-32.84-10.376-49.976-12.424
      c-2.312-0.272-4.552,0.448-6.264,1.96c-1.72,1.512-2.696,3.688-2.696,5.984v214.512c0,4.416,3.576,8,8,8H444.14
      c4.168,0,7.64-3.208,7.976-7.36c0.488-6.08,0.72-11.52,0.72-16.64C452.836,204.24,438.444,161.088,411.228,124.864z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M236.836,241.672h-192c-4.424,0-8,3.584-8,8c0,11.176,0.888,22.368,2.648,33.28l15.8-2.544
      c-1.208-7.472-1.968-15.088-2.28-22.736h175.832v183.296c-15.496-1.28-30.72-4.416-45.384-9.36l-5.112,15.168
      c18.728,6.312,38.296,9.912,58.176,10.688c0.104,0,0.208,0.008,0.312,0.008c2.064,0,4.056-0.8,5.544-2.232
      c1.584-1.512,2.464-3.592,2.464-5.768v-199.8C244.836,245.256,241.26,241.672,236.836,241.672z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M445.284,292.744c-1.504-1.944-3.824-3.072-6.28-3.072H268.836c-4.424,0-8,3.584-8,8v150.512
      c0,2.288,0.976,4.464,2.688,5.984c1.48,1.312,3.368,2.016,5.312,2.016c0.312,0,0.632-0.016,0.952-0.056
      c8.368-1,16.768-2.528,24.96-4.544l-3.832-15.536c-4.64,1.144-9.352,2.12-14.088,2.912V305.672h151.664
      c-0.552,1.824-1.136,3.64-1.744,5.448l15.16,5.112c1.856-5.504,3.496-11.104,4.848-16.64
      C447.348,297.208,446.804,294.68,445.284,292.744z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M187.204,78.52c-0.008-0.008-0.016-0.008-0.024-0.008c-11.192-8.4-24.448-12.84-38.344-12.84
      c-2.408,0-4.856,0.184-7.36,0.496c-7.8-15.936-21.272-28.584-37.816-35.264c6.592-6.992,14.872-12.504,23.984-15.928L122.02,0
      c-11.496,4.312-21.944,11.288-30.232,20.16c-1.92,2.056-3.624,4.144-5.208,6.248c-3.2-0.432-6.432-0.736-9.744-0.736
      c-39.704,0-72,32.304-72,72s32.296,72,72,72c6.904,0,13.568-1.032,19.896-2.856c9.144,12.8,22.76,21.88,38.216,25.304
      c0.008,0,0.008,0.008,0.016,0.008c4.64,1.024,9.312,1.544,13.872,1.544c15.232,0,30.024-5.488,41.632-15.44
      c0.008-0.008,0.008-0.008,0.016-0.016c14.2-12.192,22.352-29.888,22.352-48.544C212.836,109.4,203.492,90.76,187.204,78.52z
       M76.836,153.672c-30.872,0-56-25.12-56-56s25.128-56,56-56c0.216,0,0.416,0.032,0.632,0.032
      c-3.128,6.952-4.872,13.472-5.832,18.752l15.736,2.872c0.952-5.216,2.864-11.936,6.616-18.944
      c16.264,5.248,29.248,17.744,35.232,33.664c0.568,1.52,1.072,3.048,1.504,4.584c0.056,0.2,0.104,0.4,0.152,0.6
      c0.376,1.392,0.704,2.784,0.976,4.192c0.112,0.616,0.192,1.24,0.288,1.856c0.16,1.04,0.328,2.08,0.432,3.128
      c0.16,1.728,0.264,3.488,0.264,5.264c0,4.12-0.504,8.392-1.504,12.696C125.548,135.144,103.34,153.672,76.836,153.672z
       M130.764,174.12c-7.264-2.96-13.672-7.696-18.72-13.712c11.816-6.656,21.592-16.512,28.08-28.432L130.764,174.12z
       M196.172,121.672h-31.336l18.776-25.024C190.252,103.584,194.604,112.24,196.172,121.672z M170.812,87.032l-6.992,9.32
      l-13.984,18.64l-2.272-4.096v-0.008c0.4-2.144,0.728-4.312,0.928-6.52c0.224-2.24,0.344-4.48,0.344-6.696
      c0-2.648-0.168-5.256-0.448-7.832c-0.04-0.376-0.12-0.744-0.168-1.12c-0.288-2.312-0.68-4.592-1.184-6.832
      c-0.008-0.056-0.016-0.112-0.032-0.176C155.58,81.336,163.508,83.24,170.812,87.032z M146.38,177.608l6.792-30.576l20.368,23.76
      C165.412,175.68,156.012,178.104,146.38,177.608z M185.684,160.368l-19.448-22.696h29.928
      C194.748,146.016,191.132,153.848,185.684,160.368z"></path>
  </g>
</g>
<g>
  <g>
    <rect x="300.836" y="153.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="332.836" y="169.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="364.836" y="225.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="300.836" y="217.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="292.836" y="185.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="404.836" y="193.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="364.836" y="161.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="332.836" y="201.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <rect x="364.836" y="193.672" width="16" height="16"></rect>
  </g>
</g>
<g>
  <g>
    <path d="M484.836,9.672c-20.848,0-40.704,5.424-58.576,14.752c-1.56-3.552-3.68-6.952-6.568-9.84
      C408.82,3.72,388.78,9.336,386.524,10.008c-2.568,0.776-4.584,2.784-5.36,5.352c-0.672,2.248-6.296,22.288,4.584,33.168
      c1.256,1.248,2.616,2.32,4,3.32c-5.24,5.504-9.992,11.512-14.376,17.824c-1.104-1.6-2.272-3.168-3.68-4.576
      c-10.544-10.536-30.232-6.928-32.448-6.472c-2.96,0.6-5.328,2.816-6.136,5.728c-1.08,3.944-5.92,24.128,4.64,34.688
      c5.304,5.288,11.968,8.256,18.568,8.84c-4.768,14.472-7.48,29.856-7.48,45.792h16c0-11.496,1.712-22.712,4.672-33.488
      c4.416,2.496,9.656,3.992,15.328,3.992c15.296,0,25.832-18.032,26.984-20.096c1.352-2.424,1.352-5.384,0-7.816
      c-1.008-1.8-9.184-15.8-21.44-19.296c4.912-6.744,10.4-12.984,16.4-18.64c4.08,8.96,14.192,15.344,26.056,15.344
      c15.296,0,25.832-18.032,26.984-20.096c1.352-2.424,1.352-5.384,0-7.816c-0.688-1.232-4.792-8.16-11.216-13.544
      c11.544-4.192,23.728-6.544,36.232-6.544V9.672z M364.82,87.216c-0.64,1.256-1.176,2.568-1.784,3.848
      c-0.456,0.12-0.92,0.224-1.352,0.424c-3.024,1.368-8.32,0.528-12.616-3.768c-2.152-2.152-2.28-8.464-1.52-14.008
      c4.92-0.224,10.504,0.368,12.832,2.696c3.016,3.016,4.712,7,4.424,10.4C364.796,86.944,364.828,87.08,364.82,87.216z
       M395.252,100.176c-3.112,4.072-7.336,8-10.416,8c-4.112,0-7.872-1.552-10.056-3.664c1.656-3.976,3.512-7.848,5.528-11.632
      c1.44-0.432,2.952-0.704,4.528-0.704C387.924,92.176,392.14,96.104,395.252,100.176z M402.084,40.496
      c-1.704-0.704-3.424-1.68-5.016-3.28c-2.16-2.16-2.288-7.856-1.528-12.832c4.696-0.696,10.576-0.752,12.84,1.512
      c2,2,3.344,4.424,3.992,6.824C408.828,35.144,405.404,37.744,402.084,40.496z M432.836,57.672c-6.392,0-12-3.736-12.016-7.544
      c0.024-0.144,0.128-0.8,0.144-0.944c0.096-0.8,0.04-1.592-0.104-2.368c1.744-1.224,3.52-2.392,5.312-3.528
      c2.032-0.984,4.272-1.616,6.664-1.616c3.088,0,7.304,3.928,10.416,8C440.14,53.744,435.916,57.672,432.836,57.672z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M187.14,323.856c1.12-3.256,1.696-6.688,1.696-10.184c0-17.648-14.352-32-32-32c-9.752,0-18.832,4.536-24.8,11.904
      c-6.704-3.656-14.72-4.824-22.232-3.112c-7.072-5.704-15.776-8.792-24.968-8.792c-22.056,0-40,17.944-40,40
      c-17.648,0-32,14.352-32,32c0,5.416,1.344,10.608,3.872,15.224c-7.352,5.968-11.872,15.032-11.872,24.776
      c0,17.648,14.352,32,32,32c11.568,0,21.736-6.176,27.352-15.408l12.952,25.904l7.808,46.816c0.64,3.856,3.976,6.688,7.888,6.688
      h64c4.424,0,8-3.584,8-8v-47.336l7.888-47.344c0.072-0.44,0.112-0.88,0.112-1.32c22.056,0,40-14.352,40-32
      C212.836,340.104,202.236,328.456,187.14,323.856z M172.836,369.672c-1.888,0-3.856-0.232-6.376-0.752
      c-2.352-0.488-4.808,0.112-6.672,1.632c-1.864,1.52-2.952,3.792-2.952,6.2v8.264l-7.888,47.344
      c-0.072,0.432-0.112,0.872-0.112,1.312v40H99.612l-6.88-41.32c-0.136-0.784-0.376-1.544-0.736-2.264l-24-48
      c-1.36-2.704-4.128-4.416-7.16-4.416h-1.6c-2.616,0-5.072,1.28-6.56,3.424c-1.504,2.152-1.848,4.896-0.944,7.344
      c0.752,2.048,1.104,3.712,1.104,5.232c0,8.824-7.176,16-16,16s-16-7.176-16-16c0-6.624,4.216-12.632,10.496-14.944
      c2.608-0.968,4.528-3.208,5.08-5.944c0.544-2.728-0.368-5.544-2.408-7.432c-3.336-3.088-5.168-7.24-5.168-11.68
      c0-8.824,7.176-16,16-16c1.6,0,3.288,0.336,5.288,1.056c2.448,0.88,5.168,0.512,7.312-0.984c2.136-1.496,3.4-3.936,3.4-6.544
      v-9.528c0-13.232,10.768-24,24-24c6.52,0,12.64,2.608,17.216,7.344c2.264,2.352,5.744,3.088,8.768,1.848
      c6.216-2.544,13.192-0.888,17.704,3.976c1.896,2.04,4.72,2.952,7.44,2.4c2.728-0.544,4.976-2.472,5.936-5.08
      c2.312-6.272,8.312-10.488,14.936-10.488c8.824,0,16,7.176,16,16c0,3.928-1.504,7.736-4.24,10.728
      c-2.104,2.304-2.672,5.608-1.48,8.48c1.2,2.872,3.96,4.792,7.072,4.912c12.48,0.488,22.648,7.616,22.648,15.88
      C196.836,362.344,185.844,369.672,172.836,369.672z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M430.844,321.672h-8.384c-27.856,0-50.952,20.904-53.728,48.624l-3.456,34.584l-16.2,9.72l-2.584-2.584
      c-1.496-1.504-3.528-2.344-5.656-2.344h-4c-15.44,0-28,12.56-28,28c0,14.168,10.576,25.912,24.248,27.752
      c1.84,13.672,13.584,24.248,27.752,24.248c15.44,0,28-12.56,28-28v-4c0-2.12-0.84-4.16-2.344-5.656l-2.584-2.584l9.696-16.16
      l42.128-3.832c27.992-2.544,49.104-25.664,49.104-53.768C484.836,345.896,460.62,321.672,430.844,321.672z M368.18,456.328
      l4.656,4.656v0.688c0,6.616-5.384,12-12,12c-6.616,0-12-5.384-12-12v-4c0-4.416-3.576-8-8-8h-4c-6.616,0-12-5.384-12-12
      c0-6.616,5.384-12,12-12h0.688l4.656,4.656c2.592,2.6,6.616,3.088,9.776,1.2l19.64-11.784l3.584,3.584l3.584,3.584l-11.784,19.64
      C365.092,449.704,365.588,453.728,368.18,456.328z M434.284,413.504l-42.44,3.856l-10.672-10.672l3.488-34.808
      c1.952-19.504,18.2-34.208,37.8-34.208h8.384c20.944,0,37.992,17.048,37.992,38C468.836,395.448,453.988,411.712,434.284,413.504z
      "></path>
  </g>
</g>
<g>
  <g>
    <path d="M97.364,74.36c-5.656,6.776-14.968,9.168-22.64,5.808c-6.488-2.848-10.896-9.536-11.232-17.032l-15.984,0.712
      c0.6,13.536,8.76,25.688,20.784,30.968c4.376,1.92,9.024,2.84,13.656,2.84c10.352,0,20.648-4.608,27.696-13.04L97.364,74.36z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M408.084,358.984c-8.024,5.92-11.072,15.36-11.248,22.232l16,0.416c0.016-0.656,0.288-6.48,4.752-9.768
      c4.104-3.024,10.056-2.912,14.84,0.24l8.816-13.352C430.884,351.904,417.548,352,408.084,358.984z"></path>
  </g>
</g>
<g>
  <g>
    <path d="M113.5,369.088c-9.56-9.44-23.712-15.416-36.664-15.416v16c13.968,0,32,11.64,32,24v32h16v-32c0-9.624,2.336-32,24-32v-16
      C132.06,345.672,119.756,354.328,113.5,369.088z"></path>
  </g>
</g>

</svg>
  );
};

export default mealPlanIcon;